import { Draft, PayloadAction } from '@reduxjs/toolkit'
import { filter, map } from 'lodash'

import { LabelingState } from '@/stores/slices/Labeling/types'
import { initialState } from '@/stores/slices/Labeling/const'

import { LabelingNodeItem, LabelingStatus, UserShortcut } from '@/api/LabelingNode/types'

export const miscReducers = {
  setClassTagFilter: (state: Draft<LabelingState>, action: PayloadAction<string>) => {
    const classId = action.payload

    if (!state.classTagFilters.includes(classId)) {
      state.classTagFilters = [...state.classTagFilters, classId]
    } else {
      state.classTagFilters = filter(state.classTagFilters, (id) => id !== classId)
    }
  },
  /** 필터 팝오버에서 한 번에 확정할 때 쓴다. 개별 토글은 setClassTagFilter */
  setClassTagFilters: (state: Draft<LabelingState>, action: PayloadAction<{ classIds: string[], untaggedOnly: boolean }>) => {
    state.classTagFilters = action.payload.classIds
    state.showUntaggedOnly = action.payload.untaggedOnly
  },
  resetClassTagFilter: (state: Draft<LabelingState>) => {
    state.classTagFilters = []
    state.showUntaggedOnly = false
  },
  /** 이미지 탭 파일명 검색어. 목록 재조회는 filterLabelingItems 가 한다 */
  setFileSearch: (state: Draft<LabelingState>, action: PayloadAction<string>) => {
    state.fileSearch = action.payload
  },
  setHasSelectedForClustering: (state: Draft<LabelingState>, action: PayloadAction<{ selected: boolean, itemIds?: string[] }>) => {
    const { selected, itemIds } = action.payload

    state.hasSelectedForClustering = selected

    if (selected && itemIds) {
      state.originalFiles = map(
        state.originalFiles,
        (item) => (itemIds.includes(item?._id || '')
          ? ({ ...item, isSelectedForClustering: true }) as LabelingNodeItem
          : item)
      )
    }
  },
  updateUserShortcuts: (state: Draft<LabelingState>, action: PayloadAction<UserShortcut[]>) => {
    state.userShortcuts = action.payload
  },
  setHotkeysEnabled: (state: Draft<LabelingState>, action: PayloadAction<boolean>) => {
    state.isHotkeysEnabled = action.payload
  },
  updateLabelingItemStatus: (state: Draft<LabelingState>, action: PayloadAction<{ itemId: string, updatedStatus: LabelingStatus }>) => {
    const { itemId, updatedStatus } = action.payload

    state.annotation[itemId] = { ...state.annotation[itemId], status: updatedStatus }
    state.files = state.files.map((f) => (f?._id === itemId ? { ...f, status: updatedStatus } : f))
    state.originalFiles = state.originalFiles.map((f) => (f?._id === itemId ? { ...f, status: updatedStatus } : f))
  },
  resetCurrentLabeling: () => initialState,
  setCurrentTab: (state: Draft<LabelingState>, action: PayloadAction<string>) => {
    state.currentTab = action.payload
  },
  updateVideoSegmentMemo: (state: Draft<LabelingState>, action: PayloadAction<{ itemId: string, objectId: string, memoContent: string }>) => {
    const { itemId, objectId, memoContent } = action.payload
    const objects = state.annotation[itemId]?.object
    if (!objects) {
      return
    }
    state.annotation[itemId].object = map(objects, (o) => (o.id === objectId ? { ...o, memoContent } : o))
  },
}
